import React from 'react';

import { configureChains, createConfig, WagmiConfig } from 'wagmi';
import { goerli, mainnet, polygon } from 'wagmi/chains';
import { LedgerConnector } from 'wagmi/connectors/ledger';
import { MetaMaskConnector } from 'wagmi/connectors/metaMask';
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect';
import { publicProvider } from 'wagmi/providers/public';

import config from '@app/config';

import { availableConnectors, Web3WagmiConnectors } from './types';

const { walletConnectProjectId, walletConnectBloctoId } = config;

// Configure chains & providers with the Alchemy provider.
const { chains, publicClient, webSocketPublicClient } = configureChains([mainnet, goerli, polygon], [publicProvider()]);

// Metamask
const metamaskConnector = new MetaMaskConnector({ chains });

// Ledger
const ledgerConnector = new LedgerConnector({
    chains,
    options: {
        projectId: walletConnectProjectId,
    },
});

// Wallet Connect
const walletConnectConnector = new WalletConnectConnector({
    // As of now, WalletConnect will throw an error when trying to
    // connect using Blocto if more than one chain is selected below
    chains: [mainnet],
    options: {
        projectId: walletConnectProjectId,
        showQrModal: true,
        qrModalOptions: {
            enableExplorer: true,
            explorerRecommendedWalletIds: [walletConnectBloctoId],
        },
    },
});

const connectors = availableConnectors.map((connector: Web3WagmiConnectors) => {
    switch (connector) {
        case Web3WagmiConnectors.Metamask:
            return metamaskConnector;
        case Web3WagmiConnectors.Ledger:
            return ledgerConnector;
        case Web3WagmiConnectors.WalletConnect:
            return walletConnectConnector;
    }
});

// Set up client
const wagmiConfig = createConfig({
    autoConnect: false,
    connectors,
    publicClient,
    webSocketPublicClient,
});

export const Web3Provider = ({ children }: { children: React.ReactElement }) => {
    return <WagmiConfig config={wagmiConfig}>{children}</WagmiConfig>;
};
